import { Box, Button, Paper, TextField, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText, Card } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import configSiteUrls from '../../../configs/configSiteUrls';

import { useGetAcessoInformacaoByLoginMutation } from '../acessoInformacaoApiSlice';
import { ISacessoInformacao, ISacessoInformacaoList, AcessoInformacaoList } from '../types/AcessoInformacao';
import { Iso } from '@mui/icons-material';
import { AcessoInformacaoAnexo } from '../types/AcessoInformacaoAnexo';
import { useGetAcessoInformacaoAnexosQuery, useGetAcessoInformacaoAnexosRespostaQuery } from '../acessoInformacaoAnexoApiSlice';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import GeralAnexosUpload from '../../licitacao/create/GeralAnexosUpload';
import DownloadAnexoButton from '../../noticia/create/DownloadAnexoButton';
import { format } from 'date-fns';

export const AcessoInformacaoConsultaView = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [dados, setDados] = useState<AcessoInformacaoList>(ISacessoInformacaoList);

  const [consultarAcessoInformacao, status] = useGetAcessoInformacaoByLoginMutation();

  const [acessoInformacaoAnexoSalvo, setAcessoInformacaoAnexoSalvo] = useState<AcessoInformacaoAnexo[] | null>(null);
  const { data: dataAnexo, isLoading: isLoadingAnexo } = useGetAcessoInformacaoAnexosQuery({ idAcessoInformacaoAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexo) {
      setAcessoInformacaoAnexoSalvo(dataAnexo);
    }
  }, [dataAnexo]);

  const [acessoInformacaoAnexoSalvoResposta, setAcessoInformacaoAnexoSalvoResposta] = useState<AcessoInformacaoAnexo[] | null>(null);
  const { data: dataAnexoResposta, isLoading: isLoadingAnexoResposta } = useGetAcessoInformacaoAnexosRespostaQuery({ idAcessoInformacaoAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexoResposta) {
      setAcessoInformacaoAnexoSalvoResposta(dataAnexoResposta);
    }
  }, [dataAnexoResposta]);

  async function handleConsultar() {
    if (!login || !senha) {
      enqueueSnackbar('Informe o login e a senha.', { variant: 'warning' });
      return;
    }

    const result: any = await consultarAcessoInformacao({ login, senha });

    if (result?.error) {
      enqueueSnackbar('Login ou senha inválidos.', { variant: 'error' });
      return;
    }

    setDados(result.data);
    setAcessoInformacaoAnexoSalvo(null);
  }

  return (
    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
      <Paper
        sx={{
          width: '100%',
          p: 3,
          mx: 'auto',
          maxWidth: {
            xs: '100%', // celular
            sm: '600px', // tablets
            md: '800px', // telas médias
            lg: '1000px', // telas grandes
            xl: '1200px' // monitores muito grandes
          }
        }}
      >
        {!dados.id ? (
          <>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Consulte sua Solicitação da AcessoInformacao
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField label="Login" fullWidth size="small" value={login} onChange={e => setLogin(e.target.value)} />
              </Grid>

              <Grid item xs={12}>
                <TextField label="Senha" fullWidth type="password" size="small" value={senha} onChange={e => setSenha(e.target.value)} />
              </Grid>

              <Grid item xs={12}>
                <Button variant="contained" color="secondary" onClick={handleConsultar}>
                  Consultar
                </Button>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Card>
              <Accordion defaultExpanded={false}>
                <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                  <Typography color="secondary" variant="body1" gutterBottom>
                    Dados da Solicitação
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          Nome
                        </Typography>
                        <Typography variant="body1" fontWeight="500">
                          {dados.nome || 'Não informado'}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          Documento
                        </Typography>
                        <Typography variant="body1" fontWeight="500">
                          {dados.documento || 'Não informado'}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          E-mail
                        </Typography>
                        <Typography variant="body1" fontWeight="500">
                          {dados.email || 'Não informado'}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          Telefone
                        </Typography>
                        <Typography variant="body1" fontWeight="500">
                          {dados.telefone || 'Não informado'}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          Categoria
                        </Typography>
                        <Typography variant="body1" fontWeight="500">
                          {dados.categoria || 'Não informado'}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          Observação
                        </Typography>
                        <Typography variant="body1" fontWeight="500" sx={{ whiteSpace: 'pre-line' }}>
                          {dados.observacao || 'Não informado'}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>

                  {acessoInformacaoAnexoSalvo && acessoInformacaoAnexoSalvo.length > 0 && (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Box>
                          <Accordion defaultExpanded={false}>
                            <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                              <Typography color="secondary" variant="body1" gutterBottom>
                                Anexos
                              </Typography>
                            </AccordionSummary>

                            <AccordionDetails>
                              <Paper>
                                {!isLoadingAnexo && (
                                  <List dense>
                                    {acessoInformacaoAnexoSalvo.map((file: AcessoInformacaoAnexo) => (
                                      <ListItem key={file.path} disablePadding secondaryAction={<DownloadAnexoButton tipo="ACESSO_INFORMACAO" ida={file.path} fileName={file.nomeOriginal} />}>
                                        <ListItemText
                                          primary={file.nomeOriginal}
                                          primaryTypographyProps={{
                                            variant: 'body2',
                                            color: 'secondary'
                                          }}
                                        />
                                      </ListItem>
                                    ))}
                                  </List>
                                )}
                              </Paper>
                            </AccordionDetails>
                          </Accordion>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                </AccordionDetails>
              </Accordion>
            </Card>

            <Card sx={{ mt: 2 }}>
              {dados.resposta && dados.resposta.length > 0 && (
                <Accordion defaultExpanded={false}>
                  <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                    <Typography color="secondary" variant="body1" gutterBottom>
                      Dados da Resposta
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box>
                          <Typography variant="caption" color="text.secondary">
                            Data
                          </Typography>
                          <Typography variant="body1" fontWeight="500">
                            {dados.dataHoraResposta ? format(dados.dataHoraResposta, 'dd/MM/yyyy') : 'Data não disponível'}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box>
                          <Typography variant="caption" color="text.secondary">
                            Usuário
                          </Typography>
                          <Typography variant="body1" fontWeight="500">
                            {dados.usuarioResposta?.nome || 'Não informado'}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={12}>
                        <Box>
                          <Typography variant="caption" color="text.secondary">
                            Resposta
                          </Typography>
                          <Typography variant="body1" fontWeight="500">
                            {dados.resposta || 'Não informado'}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    {acessoInformacaoAnexoSalvo && acessoInformacaoAnexoSalvo.length > 0 && (
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Box>
                            <Accordion defaultExpanded={false}>
                              <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                                <Typography color="secondary" variant="body1" gutterBottom>
                                  Anexos
                                </Typography>
                              </AccordionSummary>

                              <AccordionDetails>
                                <Paper>
                                  {!isLoadingAnexo && (
                                    <>
                                      <List dense>
                                        {acessoInformacaoAnexoSalvoResposta?.map((file: AcessoInformacaoAnexo) => (
                                          <ListItem key={file.path} disablePadding secondaryAction={<DownloadAnexoButton tipo="ACESSO_INFORMACAO" ida={file.path} fileName={file.nomeOriginal} />}>
                                            <ListItemText
                                              primary={file.nomeOriginal}
                                              primaryTypographyProps={{
                                                variant: 'body2',
                                                color: 'secondary'
                                              }}
                                            />
                                          </ListItem>
                                        ))}
                                      </List>
                                    </>
                                  )}
                                </Paper>
                              </AccordionDetails>
                            </Accordion>
                          </Box>
                        </Grid>
                      </Grid>
                    )}
                  </AccordionDetails>
                </Accordion>
              )}
            </Card>

            <Button
              variant="contained"
              sx={{ mt: 3 }}
              onClick={() => {
                setDados(ISacessoInformacaoList);
                setLogin('');
                setSenha('');
              }}
            >
              Nova consulta
            </Button>

            <Button variant="outlined" sx={{ mt: 3, ml: 2 }} onClick={() => navigate(configSiteUrls.SITE_ACESSO_INFORMACAO_PUBLIC_MENU)}>
              Voltar
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
};
